import React from "react";
import Signin2 from "../pages/Signin2";
import ForgotPassword from "../pages/ForgotPassword";
import Register from "../pages/Register";
import Signin from "../pages/Signin";

const publicRoutes = [
  {
    path: "/",
    element: <Signin />
  },
  {
    path: "login",
    element: <Signin2 />
  },
  {
    path: "forgot-password",
    element: <ForgotPassword />
  },
  {
    path: "register",
    element: <Register />
  }
];

export default publicRoutes;